import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
export default {
  props: {
    value: {
      type: String,
      default: '00:00'
    },
    label: {
      type: String,
      default: null
    },
    useInput: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    numericValues: {
      type: Boolean,
      default: false
    },
    minutesInterval: {
      type: Number,
      default: 60,
      validator: function validator(value) {
        return value > 0 && value <= 60 && 60 % value === 0;
      }
    },
    from: {
      type: String,
      default: '00:00',
      validator: function validator(value) {
        // validate format and value
        return /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
      }
    },
    to: {
      type: String,
      default: '23:59',
      validator: function validator(value) {
        // validate format and value
        return /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
      }
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.inputValue = val;
    }
  },
  computed: {
    internalValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.inputValue = val;
        this.$emit('input', val);
      }
    },
    hourOptions: function hourOptions() {
      var _this = this;

      var from = moment(this.from, 'HH:mm');
      var to = moment(this.to, 'HH:mm'); // round from to the nearest minute interval

      from = moment(from).startOf('hour').add(Math.ceil(from.minutes() / this.minutesInterval) * this.minutesInterval, 'minutes'); // use moment range to generate the options

      return Array.from(moment.range(from, to).by('minutes', {
        step: this.minutesInterval
      })).map(function (date) {
        return {
          value: _this.numericValues ? parseInt(date.format('HH')) : date.format('HH:mm'),
          label: date.format('HH:mm')
        };
      });
    }
  },
  methods: {
    isValidTime: function isValidTime(timeString) {
      // Regular expression to match HH:MM format
      var timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/; // Test the string against the regex

      return timeRegex.test(timeString);
    },
    validateInput: function validateInput() {
      // if val is not a valid time revert the value to the previous one
      // otherwise set the internal value to the input value when is after the from time
      if (this.isValidTime(this.inputValue) && this.inputValue >= this.from) {
        this.internalValue = this.inputValue;
      } else {
        this.inputValue = this.internalValue;
      }
    },
    onInput: function onInput(val) {
      // if first char of val is between 2 and 9 add a padding 0
      if (val.length === 1 && val >= 2 && val <= 9) {
        this.inputValue = '0' + val + ':';
      } else {
        this.inputValue = val;
      }
    },
    onPopupShow: function onPopupShow() {
      var _this2 = this;

      var optionIndex = this.hourOptions.findIndex(function (option) {
        return option.value >= _this2.internalValue;
      });
      this.$nextTick(function () {
        _this2.$refs.timePicker.scrollTo(optionIndex);
      });
    }
  }
};